module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-up-0.b8057b70.svg";